import { Text } from "@jobber/components/Text";

const PROXTRA_SIGNUP_URL = "https://www.homedepot.com/c/pro-xtra";

function ProXtraSignUpFooter() {
    return (
        <Text size="small">
            Not a Pro Xtra member? Learn more and{" "}
            <a
                href={PROXTRA_SIGNUP_URL}
                target="_blank"
                rel="noopener noreferrer"
            >
                Sign Up Here
            </a>
        </Text>
    );
}

export default ProXtraSignUpFooter;
